export default function ProgressBar({ currentStep }) {
  const steps = [1, 2, 3, 4, 5, 6];

  return (
    <div className="flex items-center justify-center mb-8 px-4">
      <div className="flex items-center w-full max-w-7xl">
        {steps.map((step, index) => (
          <div key={step} className="flex items-center flex-1 last:flex-none">
            {/* Cercle de l'étape */}
            <div className="relative flex flex-col items-center">
              <div 
                className={`
                  w-6 h-6 
                  xs:w-7 xs:h-7
                  sm:w-8 sm:h-8 
                  md:w-10 md:h-10 
                  lg:w-12 lg:h-12
                  rounded-full flex items-center justify-center 
                  text-xs sm:text-sm md:text-base font-bold 
                  transition-all duration-300 ease-in-out
                  ring-2 ring-offset-2 ring-offset-white
                  z-10 relative
                  ${step <= currentStep 
                    ? 'bg-primary text-secondary ring-primary' 
                    : 'bg-gray-100 text-gray-500 ring-gray-200'
                  }
                  ${step === currentStep ? 'scale-110 ring-4' : ''}
                `}
              >
                {step}
              </div>
              
              {/* Label optionnel pour les étapes (masqué sur mobile) */}
              <span 
                className={`
                  hidden md:block mt-2 text-xs font-medium
                  transition-colors duration-300
                  ${step <= currentStep ? 'text-primary' : 'text-gray-400'}
                `}
              >
                Étape {step}
              </span>
            </div>
            
            {/* Ligne de connexion entre les étapes */}
            {index < steps.length - 1 && (
              <div className="flex-1 mx-0">
                <div 
                  className={`
                    h-1 xs:h-1.5 sm:h-2 w-full
                    transition-all duration-500 ease-in-out
                    ${step < currentStep ? 'bg-primary' : 'bg-gray-200'}
                  `}
                ></div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}